import React, { Component } from 'react';
import ajax from 'superagent';
import { Field } from 'redux-form';
import SelectField from './SelectField';

class AssociateTypesList extends Component {

    constructor(props) {
        super(props);
        this.state = { associateTypes: [] };
    }

    componentWillMount() {
        const ROOT_URL = process.env.API_URL;

        ajax.get(ROOT_URL + '/associate_types')
            .end((error, response) => {
                    if (!error && response) {
                        this.setState({ associateTypes: response.body.associate_types });
                    }
                }
            );
    }

    render() {
        return (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field
                        className="form-control"
                        name="associate_type_id"
                        component={SelectField}
                        options={this.state.associateTypes}
                        defaultValue={'Tipo de Asociado'}
                        label={'Tipo de Asociado'}
                        type={this.props.type}
                    />
                </div>
            </div>
        );
    }
}

export default AssociateTypesList;




/** WEBPACK FOOTER **
 ** ./src/components/AssociateTypes.js
 **/